import { MagnifyPlusCursorIcon } from './MagnifyPlusCursorIcon';

/**
 * author: Michael Richins
 * id 950E718A-089B-4266-AAFA-B9FA8BB0D3B3
 * name magnify-plus-cursor
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magnify-plus-cursor.svg
 * tags
 */
export const MagnifyAddCursorIcon = MagnifyPlusCursorIcon;
export default MagnifyAddCursorIcon